<template>
  <button
    class="d-block relative text-left primary--text rounded px-6 py-12 shadow--hover-alt fill-width"
    :style="{
      background: `linear-gradient(to right, var(--v-${color}-lighten3), var(--v-${color}-lighten2))`,
    }"
    v-ripple
  >
    <div>
      <slot />
    </div>
    <div
      class="absolute d-flex align-center"
      :style="{ top: '15%', bottom: '15%', right: '10%' }"
    >
      <slot name="icon" />
    </div>
  </button>
</template>

<script>
export default {
  props: {
    color: String,
    icon: String,
  },
}
</script>
